import * as pc from 'playcanvas';

// Screen shake state
let shakeOffset = { x: 0, y: 0 };
let shakeIntensity = 0;

// Create and setup camera
export function createCamera(app) {
    const camera = new pc.Entity('Camera');
    camera.addComponent('camera', {
        clearColor: new pc.Color(0.05, 0.05, 0.15),
        fov: 70
    });
    camera.setPosition(0, 5, 10);
    app.root.addChild(camera);

    return camera;
}

// Setup camera follow behavior
export function setupCameraFollow(app, camera, getTargetFn, isGameStartedFn) {
    app.on('update', function(dt) {
        const target = getTargetFn();
        if (!target || !isGameStartedFn()) return;

        updateScreenShake(dt);

        const targetPos = target.getPosition();
        const cameraTarget = new pc.Vec3(
            targetPos.x * 0.5,  // Don't follow X too closely
            targetPos.y + 6,
            targetPos.z + 12
        );

        const currentPos = camera.getPosition();
        const newPos = new pc.Vec3().lerp(currentPos, cameraTarget, 0.05);

        // Apply shake offset
        camera.setPosition(
            newPos.x + shakeOffset.x,
            newPos.y + shakeOffset.y,
            newPos.z
        );

        // Look at a point slightly above the target
        camera.lookAt(new pc.Vec3(targetPos.x, targetPos.y + 1, targetPos.z));
    });
}

// Setup camera follow for two players (average position)
export function setupCameraFollowMultiplayer(app, camera, getPlayersFn, isGameStartedFn) {
    app.on('update', function(dt) {
        const players = getPlayersFn();
        if (!players || players.length === 0 || !isGameStartedFn()) return;

        updateScreenShake(dt);

        // Calculate average position of all living players
        let avgX = 0, avgY = 0, avgZ = 0;
        let count = 0;

        for (const player of players) {
            if (player.health > 0) {
                const pos = player.getPosition();
                avgX += pos.x;
                avgY += pos.y;
                avgZ += pos.z;
                count++;
            }
        }

        if (count === 0) return;

        avgX /= count;
        avgY /= count;
        avgZ /= count;

        const cameraTarget = new pc.Vec3(
            avgX * 0.5,
            avgY + 6,
            avgZ + 12
        );

        const currentPos = camera.getPosition();
        const newPos = new pc.Vec3().lerp(currentPos, cameraTarget, 0.05);

        camera.setPosition(
            newPos.x + shakeOffset.x,
            newPos.y + shakeOffset.y,
            newPos.z
        );

        camera.lookAt(new pc.Vec3(avgX, avgY + 1, avgZ));
    });
}

// Trigger screen shake
export function screenShake(intensity) {
    shakeIntensity = Math.max(shakeIntensity, intensity * 0.3);
}

// Update screen shake
function updateScreenShake(dt) {
    if (shakeIntensity > 0) {
        shakeOffset.x = (Math.random() - 0.5) * shakeIntensity;
        shakeOffset.y = (Math.random() - 0.5) * shakeIntensity;
        shakeIntensity *= 0.9; // Decay
        if (shakeIntensity < 0.01) {
            shakeIntensity = 0;
            shakeOffset.x = 0;
            shakeOffset.y = 0;
        }
    }
}

// Get current shake offset
export function getShakeOffset() {
    return { ...shakeOffset };
}

// Reset shake
export function resetShake() {
    shakeIntensity = 0;
    shakeOffset = { x: 0, y: 0 };
}

// Set camera position directly
export function setCameraPosition(camera, x, y, z) {
    camera.setPosition(x, y, z);
}

// Make camera look at point
export function setCameraLookAt(camera, target) {
    camera.lookAt(target);
}
